import React from "react";
import Select from "react-select";
import { Link } from "react-router";
import { Checkbox } from "material-ui";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../../stores/EventBucketStore";
import EventBucketActions from "../../actions/EventBucketActions";
import AnalyticsStore from "../../stores/AnalyticsStore";
import AnalyticsActions from "../../actions/AnalyticsActions";
import EventStore from "../../stores/EventStore";
import EventActions from "../../actions/EventActions";

import EventTicketSalesChart from "./event-ticket-sales-chart.jsx";
import TicketsAtAGlance from "./tickets-at-a-glance.jsx";

import WorkingIndicator from "./working-indicator.jsx";
import InlineNoticeLabel from "./inline-notice-label.jsx";
import GenericAnalyticsTable from "./generic-analytics-table.jsx";

import StatsBlockContainer from "./stats-block-container.jsx";
import StatsBlock from "./stats-block.jsx";

import * as util from "../../util";

class EventAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSalesChannels: false
    };
  }

  static getStores() {
    return [EventBucketStore, EventStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    const eventState = EventStore.getState();

    return {
      isFetching: eventState.isFetching,
      getEventById: EventStore.getEventById,
      getEventSalesDetailAnalytics: AnalyticsStore.getEventSalesDetailAnalytics
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (force === true || newProps.eventId !== this.props.eventId) {
      AnalyticsActions.fetchEventSalesDetailAnalytics.defer(newProps.eventId);
      EventActions.fetchOne.defer(newProps.eventId);
    }
  }

  getTicketData(event) {
    return {
      unlimited: event.unlimited,
      quantity_sold: event.quantity_sold,
      quantity_remaining: event.quantity_remaining,
      quantity: event.quantity
    };
  }

  getStyles() {
    return {
      summary: {
        position: "relative",
        border: "1px solid #0288d1",
        padding: "1em",
        margin: "1em 0",
        fontSize: "15pt",
        lineHeight: 1.4,
        color: "rgb(33,33,33)"
      },
      emphasis: {
        color: "#0288d1"
      },
      insightsBadge: {
        float: "right",
        fontSize: "10pt"
      },
      salesChannels: {
        display: "inline-block",
        marginTop: "1em"
      }
    };
  }

  render() {
    const { isFetching, eventId } = this.props,
      { showSalesChannels } = this.state,
      event = this.props.getEventById(eventId),
      eventSalesDetailAnalytics =
        this.props.getEventSalesDetailAnalytics(eventId),
      styles = this.getStyles();

    if (!eventSalesDetailAnalytics || !event) {
      return <WorkingIndicator fullPage={true} />;
    }

    const start = moment(event.start_time),
      ticketData = this.getTicketData(event),
      inFuture = start > moment();

    let entries = (
      event.ticket_buckets.length > 1 ? [{ id: "default" }] : []
    ).concat(
      [].concat.apply(
        [],
        event.ticket_buckets.map(b =>
          [b]
            .concat(
              b.variants.length
                ? [{ id: `${b.id}-default_variant`, variant: true }]
                : []
            )
            .concat(
              b.variants.map(b => {
                b.variant = true;
                return b;
              })
            )
        )
      )
    );

    if (showSalesChannels) {
      entries = entries
        .map(e =>
          e.id === "default" || (e.variants && e.variants.length)
            ? [e]
            : [
                e,
                {
                  type: "channel",
                  id: `${e.id}--channel--web`,
                  name: "Web",
                  fromVariant: e.variant
                },
                {
                  type: "channel",
                  id: `${e.id}--channel--box_rush`,
                  name: "Box office",
                  fromVariant: e.variant
                },
                {
                  type: "channel",
                  id: `${e.id}--channel--rush_line`,
                  name: "Rush line",
                  fromVariant: e.variant
                }
              ]
        )
        .reduce((a, b) => a.concat(b), []);
    }

    return (
      <div>
        <StatsBlockContainer
          style1={{ maxWidth: 120 }}
          style2={{ maxWidth: 120 }}
          style3={{ maxWidth: 120 }}
        >
          <TicketsAtAGlance event={event} />
          <StatsBlock
            value={util.formatNumber(eventSalesDetailAnalytics.total.pass_uses)}
            label="Passholder tickets"
          />
          <StatsBlock
            value={util.formatNumber(eventSalesDetailAnalytics.total.comps)}
            label={
              <div>
                <div>Comp</div>
                <div>tickets</div>
              </div>
            }
          />
          <StatsBlock
            value={util.formatNumber(
              (eventSalesDetailAnalytics.total.quantity || 0) -
                eventSalesDetailAnalytics.total.pass_uses -
                eventSalesDetailAnalytics.total.comps
            )}
            label="Standalone tickets"
          />
          <StatsBlock
            value={util.formatPrice(eventSalesDetailAnalytics.total.net)}
            label="Net standalone ticket sales"
          />
        </StatsBlockContainer>

        <div style={styles.summary}>
          <div style={styles.insightsBadge}>
            <i>event insights</i>{" "}
            <InlineNoticeLabel label="beta" style={{ verticalAlign: 2 }} />
          </div>
          {event.is_virtual ? (
            <div>
              The virtual screening{" "}
              <strong style={styles.emphasis}>{event.name}</strong>:
            </div>
          ) : event.is_dated ? (
            <div>
              The event <strong style={styles.emphasis}>{event.name}</strong>{" "}
              {inFuture ? "will begin" : "occurred"} {start.fromNow()}.
            </div>
          ) : (
            <div>
              The event <strong style={styles.emphasis}>{event.name}</strong>:
            </div>
          )}
          <ul
            style={{
              marginTop: 0,
              marginBottom: 0,
              marginLeft: "-1em",
              listStyle:
                "square inside url('data:image/gif;base64,R0lGODlhBQAKAIABAAAAAP///yH5BAEAAAEALAAAAAAFAAoAAAIIjI+ZwKwPUQEAOw==')"
            }}
          >
            {!event.is_virtual && event.is_dated ? (
              <li>
                {start.format("lll")}{" "}
                {event.venue && event.venue.name ? `@ ${event.venue.name}` : ""}
              </li>
            ) : null}
            <li>
              {ticketData.unlimited ? (
                `An unlimited number of tickets ${
                  inFuture ? "are" : "were"
                } available; ${ticketData.quantity_sold} tickets ${
                  inFuture ? "have been" : "were"
                } issued.`
              ) : (
                <span>
                  {(
                    (ticketData.quantity_sold / ticketData.quantity) * 100 || 0
                  ).toFixed(1)}
                  % capacity sold;{" "}
                  {inFuture
                    ? `${ticketData.quantity_remaining}/${ticketData.quantity} tickets remain available.`
                    : `${ticketData.quantity_sold}/${ticketData.quantity} tickets were issued.`}
                </span>
              )}
            </li>
            <li>
              Of tickets issued,{" "}
              {(
                (eventSalesDetailAnalytics.total.pass_uses /
                  eventSalesDetailAnalytics.total.quantity) *
                  100 || 0
              ).toFixed(1)}
              % allocated to passholders,{" "}
              {(
                (eventSalesDetailAnalytics.total.comps /
                  eventSalesDetailAnalytics.total.quantity) *
                  100 || 0
              ).toFixed(1)}
              % comp,{" "}
              {(
                100 -
                  ((eventSalesDetailAnalytics.total.pass_uses +
                    eventSalesDetailAnalytics.total.comps) /
                    eventSalesDetailAnalytics.total.quantity) *
                    100 || 0
              ).toFixed(1)}
              % standalone.
            </li>
          </ul>
        </div>

        <GenericAnalyticsTable
          eventBucket={event.event_bucket}
          label="Ticket bucket"
          noLink={true}
          csvLabel={`${util.snakeCase(event.name)}-sales-breakdown`}
          source={event.ticket_buckets.reduce(
            (v, b) => {
              v[b.id] = b;
              if (b.variants && b.variants.length) {
                v[`${b.id}-default_variant`] = {
                  name: "Default",
                  nameLabel: <i style={{ marginLeft: "1em" }}>Default</i>,
                  rowStyle: { fontStyle: "italic" }
                };
                b.variants.map(variant => {
                  v[variant.id] = variant;
                  v[variant.id].nameLabel = (
                    <i style={{ marginLeft: "1em" }}>{variant.name}</i>
                  );
                  v[variant.id].rowStyle = { fontStyle: "italic" };
                });
              }
              return v;
            },
            {
              default: {
                name: "TOTAL",
                nameLabel: <strong>TOTAL</strong>,
                rowStyle: { fontWeight: "bold" }
              }
            }
          )}
          columns={[
            { label: "Quantity", value: "quantity" },
            { label: "Pass", value: "pass_uses" },
            { label: "Comps", value: "comps" },
            { label: "Standalone", value: "standalone" },
            { label: "Gross", value: "gross" },
            { label: "Net", value: "net" },
            { label: "Fees", value: "fee" }
          ]
            .concat(
              eventSalesDetailAnalytics.total.deferred_fee
                ? [
                    {
                      label: "Deferred fees",
                      value: "deferred_fee"
                    }
                  ]
                : []
            )
            .concat([
              { label: "Tax collected", value: "tax" },
              { label: "Cash", value: "cash" },
              { label: "Check", value: "check" },
              { label: "Credit (net)", value: "credit_net" }
            ])}
          data={entries.map(b => {
            let { id, type, name, fromVariant } = b,
              data =
                id === "default"
                  ? eventSalesDetailAnalytics.total
                  : eventSalesDetailAnalytics.by_ticket_bucket[id];

            if (!data) {
              data = new Proxy(
                {},
                {
                  get() {
                    return 0;
                  }
                }
              );
            }

            let _source;
            if (type === "channel") {
              _source = {
                name,
                nameLabel: (
                  <i style={{ marginLeft: `${fromVariant ? 2 : 1}em` }}>
                    {name}
                  </i>
                ),
                rowStyle: { fontStyle: "italic" }
              };
            }

            return {
              id,
              _source,
              pass_uses: data.pass_uses,
              comps: data.comps,
              standalone: data.quantity - data.pass_uses - data.comps,
              gross: { label: util.formatPrice(data.gross), value: data.gross },
              net: { label: util.formatPrice(data.net), value: data.net },
              fee: {
                label: util.formatPrice(
                  data.gross - data.net - (data.deferred_fee || 0)
                ),
                value: data.gross - data.net - (data.deferred_fee || 0)
              },
              deferred_fee: {
                label: util.formatPrice(data.deferred_fee),
                value: data.deferred_fee
              },
              tax: { label: util.formatPrice(data.tax), value: data.tax },
              quantity: {
                label: util.formatNumber(data.quantity),
                value: data.quantity
              },
              cash: { label: util.formatPrice(data.cash), value: data.cash },
              check: { label: util.formatPrice(data.check), value: data.check },
              credit_net: {
                label: util.formatPrice(data.credit_net),
                value: data.credit_net
              }
            };
          })}
        />

        <Checkbox
          style={styles.salesChannels}
          label="Show sales channels"
          checked={showSalesChannels}
          onCheck={() =>
            this.setState({ showSalesChannels: !showSalesChannels })
          }
        />

        {/*<pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>{JSON.stringify(eventSalesDetailAnalytics)}</pre>*/}
      </div>
    );
  }
}

export default connectToStores(EventAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/partials/event-analytics-widget.jsx